import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { useRequiredWorkspaceOperationsContext } from '../../../../workspace/operationsContext'
import { DeleteWorkspaceButton } from '../../../deleteWorkspaceButton/DeleteWorkspaceButton'
import { ManageSection } from '../../../manageSection/ManageSection'
import { useChangesetApplicationErrors } from '../workspaceOperations/useChangesetApplicationErrors'
import { ChangeWorkspaceBranchButton } from './ChangeWorkspaceBranchButton'
import { CloseWorkspaceButton } from './CloseWorkspaceButton'
import { DownloadWorkspaceButton } from './DownloadWorkspaceButton'
import { OpenWorkspaceButton } from './OpenWorkspaceButton'
import { RebaseWorkspaceButton } from './RebaseWorkspaceButton'
import { UploadWorkspaceButton } from './UploadWorkspaceButton'

export const ManageWorkspace = () => {
  const translate = useTranslate()
  const { workspaceKey } = useRequiredWorkspaceOperationsContext()
  const changesetErrors = useChangesetApplicationErrors()
  const workspaceChangesetErrors = changesetErrors.filter(
    ({ location }) => location === 'workspace',
  )

  return (
    <div className="flex flex-col gap-y-4 p-1">
      {!!workspaceChangesetErrors.length && (
        <Alert
          severity="error"
          title={translate(
            'workspaceManagement.workspaceInformation.changesetError',
          )}
        />
      )}
      <ManageSection
        title={translate(
          'workspaceDetailsPanel.tabs.manage.section.common.title',
        )}
        options={[
          {
            label: translate('workspaceDetailsPanel.button.openWorkspace'),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.common.help.open',
            ),
            button: <OpenWorkspaceButton />,
          },
          {
            label: translate('workspaceDetailsPanel.button.closeWorkspace'),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.common.help.close',
            ),
            button: <CloseWorkspaceButton />,
          },
          {
            label: translate('workspaceDetailsPanel.button.deleteWorkspace'),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.common.help.delete',
            ),
            button: (
              <DeleteWorkspaceButton
                variant="manage"
                workspaceKey={workspaceKey}
              />
            ),
          },
        ]}
      />
      <ManageSection
        title={translate(
          'workspaceDetailsPanel.tabs.manage.section.update.title',
        )}
        options={[
          {
            label: translate('workspaceDetailsPanel.button.rebase'),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.common.help.rebase',
            ),
            button: <RebaseWorkspaceButton />,
          },
          {
            label: translate('workspaceDetailsPanel.button.changeBranch'),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.update.help.changeBranch',
            ),
            button: <ChangeWorkspaceBranchButton />,
          },
        ]}
      />
      <ManageSection
        title={translate(
          'workspaceDetailsPanel.tabs.manage.section.export.title',
        )}
        options={[
          {
            label: translate(
              'workspaceDetailsPanel.tabs.manage.downloadPackage',
            ),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.export.help.downloadPackage',
            ),
            button: <DownloadWorkspaceButton />,
          },
          {
            label: translate('workspaceDetailsPanel.tabs.manage.uploadPackage'),
            description: translate(
              'workspaceDetailsPanel.tabs.manage.section.export.help.uploadPackage',
            ),
            button: <UploadWorkspaceButton />,
          },
        ]}
      />
    </div>
  )
}
